import http from 'utils/http';
import _ from 'lodash';
import { notification } from 'antd';
import { UNAUTHENTICATION, SUCCESS_HTTP_CODE, FAILED_HTTP_CODE, PASSWORD_EXPIRATION_CODE } from 'config/app.config.js';
import { deRegisterLoginUser } from 'views/LoginForm/flow/actions';
import fetch from 'isomorphic-fetch';
import { baseUrl } from 'config/env.config.js';
import { getAuthorization } from 'utils/common';
import {
  HTTP_ACTION_DONE,
  HTTP_ACTION_DOING,
  HTTP_ACTION_ERROR
} from './constants';
import allInfos from 'i18n/global/info';

import { addError, addAuthError } from '../error/action';

const successNotify = message => {
  notification.success({
    message,
    duration: 3
  });
};

const faultNotify = message => {
  notification.error({
    message,
    duration: 3
  });
};

const defaultCallback = (
  callbackConfig,
  method,
  requestResult = { data: {}, statusCode: 0 }
) => {
  const { successMessage, callbackAction } = callbackConfig;
  const info = allInfos[window.globalLanguage];
  // Check with _.isEmpty on js function will return true
  if (_.isFunction(callbackAction)) {
    callbackAction(requestResult);
  } else if (
    SUCCESS_HTTP_CODE.indexOf(requestResult.statusCode) > -1 &&
    method !== 'get'
  ) {
    if (!_.isEmpty(successMessage)) {
      successNotify(successMessage);
    } else {
      successNotify(info[method]);
    }
  }
};
const dispatch = (
  method,
  url,
  request,
  dispatcher = () => {},
  callbackConfig
) => {
  dispatcher({
    type: HTTP_ACTION_DOING,
    payload: {}
  });
  return request
    .then(({ data, statusCode }) => {
      dispatcher({ type: HTTP_ACTION_DONE });
      defaultCallback(callbackConfig, method, { data, statusCode });
      if (statusCode === UNAUTHENTICATION.CODE) {
        // 如果是401为授权
        // 由于是异步的操作，如果有多个请求的话，当url已经跳转到'/auth/login'的时候，还是会有请求进入这个条件,
        // 当token过期的时候，在登出前会记录用户当前的url，并在登陆的时候跳转到该url
        const errorMessage = data.error || data.message;
        dispatcher(addAuthError(errorMessage));
        dispatcher(deRegisterLoginUser(window.location.pathname !== '/auth/login' ? window.location.pathname : ''));
        return Promise.reject();
      }
      if (SUCCESS_HTTP_CODE.indexOf(statusCode) > -1) {
        return data;
      }
      if (FAILED_HTTP_CODE.indexOf(statusCode) > -1 && !_.isEmpty(data.message)) {
        faultNotify(data.message);
        if (data.code === PASSWORD_EXPIRATION_CODE) {
          setTimeout(() => {
            window.location.replace('/auth/forgotPassword?resetRequired=true');
          }, 500);
          return;
        }
        return Promise.reject();
      }
      if (data && (data.error || data.errors || data.message || data.force_logout)) {
        let { errors } = data;
        errors = errors || data.status_code;
        if (!_.isEmpty(data.errors)) {
          Object.keys(errors).forEach(key => {
            const msgs = errors[key];
            msgs.forEach(msg => {
              dispatcher(addError(msg));
            });
          });
        } else if (data.error) {
          if (data.force_logout) {
            dispatcher(addError(data));
          } else {
            dispatcher(addError(data.error));
          }
        } else if (data.message) {
          dispatcher(addError(data.message));
        }
        return Promise.reject();
      }
    })
    .catch(err => {
      dispatcher({
        type: HTTP_ACTION_ERROR
      });
      return Promise.reject(err);
    });
};

export const post = (
  url,
  data = {},
  dispatcher,
  callbackConfig = { successMessage: '', callbackAction: null },
  httpConfig = { realHeaders: {}, apiDomain: '' }
) =>
  dispatch(
    'post',
    url,
    http('post', url, data, httpConfig.realHeaders, httpConfig.apiDomain),
    dispatcher,
    callbackConfig
  );

export const get = (
  url,
  data,
  dispatcher,
  callbackConfig = { successMessage: '', callbackAction: null },
  httpConfig = { realHeaders: {}, apiDomain: '' }
) =>
  dispatch(
    'get',
    url,
    http('get', url, data, httpConfig.realHeaders, httpConfig.apiDomain),
    dispatcher,
    callbackConfig
  );

export const httpDelete = (
  url,
  data,
  dispatcher,
  callbackConfig = { successMessage: '', callbackAction: null },
  httpConfig = { realHeaders: {}, apiDomain: '' }
) =>
  dispatch(
    'httpDelete',
    url,
    http('delete', url, data, httpConfig.realHeaders, httpConfig.apiDomain),
    dispatcher,
    callbackConfig
  );

export const patch = (
  url,
  data,
  dispatcher,
  callbackConfig = { successMessage: '', callbackAction: null },
  httpConfig = { realHeaders: {}, apiDomain: '' }
) =>
  dispatch(
    'patch',
    url,
    http('patch', url, data, httpConfig.realHeaders, httpConfig.apiDomain),
    dispatcher,
    callbackConfig
  );

export const uploadForm = async (
  url,
  data,
  dispatcher,
  callbackConfig = { successMessage: '', callbackAction: null },
) => {
  dispatcher({ type: HTTP_ACTION_DOING });
  const fetchAction = fetch(`${baseUrl}${url}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: getAuthorization(),
    },
    body: data,
  });

  const response = await fetchAction;
  const responseData = await response.json();
  const promise = Promise.resolve({ data: responseData, statusCode: response.status });

  return dispatch(
    'post',
    url,
    promise,
    dispatcher,
    callbackConfig
  );
};




// WEBPACK FOOTER //
// ./src/store/http/httpAction.js